import { IDBPDatabase } from 'idb'

import asyncForEach from 'utils/asyncForEach'

import { IDBSchema } from '../types'

/**
 * CHANGES:
 *
 * - Save `tabOrder` for every project
 */

export default (
  database: IDBPDatabase<IDBSchema>,
  transaction: IDBTransaction,
  next: () => void
) => {
  STUDIO_ENV_DEVELOPMENT && console.log('---Running migration for v5---')

  const tabsStore = transaction.objectStore('tabs')
  const projectsStore = transaction.objectStore('projects')

  // First, we get all tabs and projects
  const tabsRequest = tabsStore.getAll()
  tabsRequest.onsuccess = () => {
    const projectsRequest = projectsStore.getAll()
    projectsRequest.onsuccess = () => {
      const tabs = tabsRequest.result
      const projects = projectsRequest.result
      STUDIO_ENV_DEVELOPMENT && console.log('Found all tabs', tabs)
      STUDIO_ENV_DEVELOPMENT && console.log('Found all projects', projects)

      // Then, for each project, save the IDs of all tabs in that project to project.tabOrder
      asyncForEach(
        projects,
        (project, next) => {
          STUDIO_ENV_DEVELOPMENT && console.log('Updating project', project)
          project.tabOrder = tabs
            .filter(t => t.projectId === project.id)
            .map(t => t.id)
          STUDIO_ENV_DEVELOPMENT &&
            console.log('Adding tabOrder', project.tabOrder)
          projectsStore.put(project).onsuccess = next
        },
        () => {
          STUDIO_ENV_DEVELOPMENT && console.log('---Migrated to v5---')
          return next()
        }
      )
    }
  }
}
